// extracted by mini-css-extract-plugin
export default {"container":"select_container__X0iHQ","icon":"select_icon__85Y6M"};